import { render } from "./boneText.vue?vue&type=template&id=1a0d3e48&scoped=true"
import script from "./boneText.vue?vue&type=script&lang=ts"
export * from "./boneText.vue?vue&type=script&lang=ts"

import "./boneText.vue?vue&type=style&index=0&id=1a0d3e48&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1a0d3e48"

export default script